import React, { useEffect, useState } from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import { doc, getDoc, updateDoc } from "firebase/firestore"
import { useParams } from "react-router-dom"
import { db } from '../../../firebase'
import ConfirmStatusBox from '../../../components/ConfirmStatusBox'

const Single = ({user}) => {

  const {releaseId} = useParams()


  const [ releaseData, setReleaseData ] = useState("")

  const [objectFuture, setObjectFuture] = useState([])

  const [openStatus, setOpenStatus] = useState(false)
  
  const [ openModal, setOpenModal ] = useState(false)
  
  const closeModal = () => setOpenModal(false)


  const getReleases = async() => {

      const docRef = doc(db, "releases", releaseId);

      const docSnap = await getDoc(docRef);

    
      
      if (docSnap.exists()) {

        setReleaseData({id: docSnap.id, status: docSnap.data().status, date: docSnap.data().date})

        setObjectFuture(docSnap.data().futureRelease)
        // console.log(userData)
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
  }

  useEffect(()=>{

    getReleases()
    
  }, [releaseData])


   const handleStatus = async() => {
      
          
          const releaseRef = doc(db, "releases", releaseId);
      
          await updateDoc(releaseRef, {
      
          status: releaseData.status === "active" ? 'inactive' : 'active', 
      
       })
      
        setOpenStatus(false)
      
        }


     const Modal = ({open, close}) => {
     
    if(!open) return null
    return(
     <div style={{
      backgroundColor: 'black',
      widows:'100%',
      height:'100%',
     }}>
       <div style={{

        maxWidth: 600,
        backgroundColor: 'white',
      }}>
       
         <div className="modalRight">
           <p className="closeBtn" onClick={close}>X</p>
           <div></div>

 
         </div>
       </div>
     </div>
    )
}
     


  // const arrayOfObjects = releaseData.futureRelease;


  return (
    <div className='single'>
      <Modal open={openModal} close={closeModal} />
      <Sidebar/>
      <div className='singleContainer'>
        <Navbar/>
        <div className="top">
          <div className="left">
            <div style={{display: 'flex', flexDirection:'row', alignItems:'center', gap:20, marginLeft:20}}>
            <h2 className='title'>Future Release Information</h2>

            </div>
            <div className='item'>
       
                <div className="details">

                  <h3 className='itemTitle'>{releaseData.date}</h3>


                      
                  
    

                  <div className='detailItem'>

                    <div style={{marginTop:20, marginBottom:20}}>

                        <span className='itemKey'>Status:</span>

                        <a onClick={(event)=> {event.preventDefault(); setOpenStatus(true);}}  style={{ border: '1px solid green', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', marginTop:'20px', marginBottom: '20px', backgroundColor:releaseData.status === "active" ? "green" : "red", cursor:'pointer'}}>
                          <span style={{color:'white', fontWeight:'bold'}}>{releaseData.status === "active" ? "Active" : "Inactive"}</span>
                        </a>

                    </div>
                  

                  </div>

                  {
                    objectFuture.map((item, index) => (

                        <div key={index}>

                        <div className='detailItem'>
                          <span className='itemKey'>Title:</span>
                          <span className='itemValue'>{item.link}</span>
                        </div>

                        <div className='detailItem'>
                          <span className='itemKey'>Message:</span>
                          <span className='itemValue'>{item.message}</span>
                        </div>
                      
                      
                      </div>

                    )

                    

                    )
                  }

                </div>

           
            </div>
          </div>
        
        </div>

        <ConfirmStatusBox
          openStatus={openStatus}
          closeDialog={() => setOpenStatus(false)}
          statusFunction={handleStatus }
        />
      
      </div>
    </div>
  )
}

export default Single